window.invisibleRecaptchaSubmit_diag_form = function(token) {
  const form = document.getElementById('diag-form');
  if (form) {
    form.submit();
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const diag = document.querySelector(".js-diag");
  if (!diag) return;

  const steps = Array.from(diag.querySelectorAll(".o-diag__step"));
  let currentStep = 0;
  const form = diag.closest("form");
  let recaptchaWidgetId = null;

  const progressBar = document.querySelector(".js-diag-progress .c-header__indicator");

  function updateProgress() {
    if (!progressBar) return;
    const total = steps.length;
    const percent = ((currentStep + 1) / total) * 100;
    progressBar.style.setProperty("--progress", `${percent}%`);
  }

  function showStep(index) {
    steps.forEach((step, i) => {
      const isCurrent = i === index;
      step.classList.toggle("current", isCurrent);
      step.style.display = isCurrent ? "block" : "none";
    });

    steps[index].scrollIntoView({ behavior: "smooth", block: "start" });

    updateNextButtonState();
    attachInputListeners();
    updateProgress();
  }

  function updateNextButtonState() {
    const step = steps[currentStep];
    const nextButton = step.querySelector(".js-diag-next-button");

    if (!nextButton) return;

    const fieldsets = step.querySelectorAll(".c-form-fieldset");
    let allValid = fieldsets.length > 0;

    fieldsets.forEach(fieldset => {
      const inputs = fieldset.querySelectorAll("input:not([type='hidden']), select");
      let valid = false;

      inputs.forEach(input => {
        if (input.type === "radio" || input.type === "checkbox") {
          if (input.checked) valid = true;
        }
        else if (input.tagName === "SELECT") {
          if (input.value !== "") valid = true;
        }
      });

      if (!valid) allValid = false;
    });

    if (allValid) {
      nextButton.removeAttribute("aria-disabled");
      nextButton.removeAttribute("aria-hidden");
    } else {
      nextButton.setAttribute("aria-disabled", "true");
      nextButton.setAttribute("aria-hidden", "true");
    }
  }

  function attachInputListeners() {
    const step = steps[currentStep];
    const inputs = step.querySelectorAll("input:not([type='hidden']), select");

    inputs.forEach(input => {
      input.removeEventListener("input", updateNextButtonState);
      input.removeEventListener("change", updateNextButtonState);

      input.addEventListener("input", updateNextButtonState);
      input.addEventListener("change", updateNextButtonState);
    });
  }

  function initRecaptcha() {
    const submitButton = document.querySelector(".js-diag-submit-button");
    if (!submitButton) return;

    const sitekey = submitButton.getAttribute("data-sitekey");
    const callbackName = submitButton.getAttribute("data-callback");

    if (!sitekey) {
      console.error("data-sitekey manquant");
      return;
    }

    if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
      try {
        const recaptchaContainer = document.createElement('div');
        recaptchaContainer.id = 'recaptcha-container';
        form.appendChild(recaptchaContainer);

        recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
          'sitekey': sitekey,
          'size': 'invisible',
          'callback': callbackName || 'invisibleRecaptchaSubmit_diag_form'
        });

        console.log("reCAPTCHA initialisé avec l'ID:", recaptchaWidgetId);
      } catch (error) {
        console.error("Erreur lors de l'initialisation de reCAPTCHA:", error);
      }
    } else {
      setTimeout(initRecaptcha, 100);
    }
  }

  if (typeof grecaptcha !== 'undefined') {
    grecaptcha.ready(initRecaptcha);
  } else {
    window.addEventListener('load', () => {
      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(initRecaptcha);
      } else {
        setTimeout(initRecaptcha, 500);
      }
    });
  }

  showStep(currentStep);

  const nextButtons = diag.querySelectorAll(".js-diag-next-button");
  nextButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();

      if (button.getAttribute("aria-disabled") === "true") return;

      const isSubmitButton = button.classList.contains("js-diag-submit-button");

      if (isSubmitButton) {
        currentStep++;
        showStep(currentStep);

        if (recaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
          grecaptcha.execute(recaptchaWidgetId);
        } else {
          setTimeout(() => form.submit(), 1500);
        }

        return;
      }

      if (currentStep < steps.length - 1) {
        currentStep++;
        showStep(currentStep);
      }
    });
  });

  const prevButtons = diag.querySelectorAll(".js-diag-prev-button");
  prevButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();

      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
      }
    });
  });
});
